import { render, staticRenderFns } from "./grouping-question-solution-component.vue?vue&type=template&id=135d81fc&scoped=true&"
import script from "./grouping-question-solution-component.vue?vue&type=script&lang=ts&"
export * from "./grouping-question-solution-component.vue?vue&type=script&lang=ts&"
import style0 from "./grouping-question-solution-component.vue?vue&type=style&index=0&id=135d81fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d81fc",
  null
  
)

export default component.exports